import paths from "../paths";
import { IUserProfileDetails } from "./profileInterface";
import { ProfileKisaanClient } from "./profileKisanClient";

export const getProfileUser = async (config: {
  userId: string;
  realmId: string;
  headers;
}): Promise<IUserProfileDetails> => {
  try {
    const response = await ProfileKisaanClient.get<IUserProfileDetails>(
      paths.editProfileSubmit(config.userId, config.realmId)
    );
    return response.data;
  } catch (e) {
    console.error('Error in getProfileUser', e);
    throw e;
  }
};
